import React from "react";
import { useTranslation } from "react-i18next";
import { Link as MuiLink, Typography } from "@mui/material";
import { Link } from "react-router";

export const SignupPageLoginQuestion = () => {
  const { t } = useTranslation();

  return (
    <Typography variant="body3" align="center" color="textSecondary">
      {t("signupPage.loginMessage.question")}{" "}
      <MuiLink
        component={Link}
        to="/login"
        data-testid="signup-question-link-login"
        underline="hover"
      >
        {t("signupPage.loginMessage.linkText")}
      </MuiLink>
    </Typography>
  );
};
